// extracted by mini-css-extract-plugin
module.exports = {"md":"panelmenu-navbar-slot-right_md_1Mmc6","ios":"panelmenu-navbar-slot-right_ios_34G0y","navRight":"panelmenu-navbar-slot-right_navRight_3a8gL"};